import { createRoutes } from 'shared/hocs'

import { AthleteOverview } from './overview'
import { AthleteView } from './view'

export const Athletes = createRoutes(({ match }) => [
  {
    path: `${match.path}/:athleteId`,
    component: AthleteView,
  },
  {
    exact: true,
    path: match.path,
    component: AthleteOverview,
  },
])
